import { v4 as uuid } from 'uuid';
const AUTH_TOKEN = 'AUTH_TOKEN';
const MS_AUTH_TOKEN = 'MS_AUTH_TOKEN';
const SIGNALR_TOKEN = 'SIGNALR_TOKEN';
const BROWSER_SESSION_ID = 'BROWSER_SESSION_ID';
const EVENT_TOKEN = 'EVENT_TOKEN';
// Per-tab (sessionStorage) selected company
const SELECTED_COMPANY_ID_SESSION = 'SELECTED_COMPANY_ID_SESSION';
// Cross-tab logout broadcast (localStorage storage event)
const LOGOUT_BROADCAST = 'LOGOUT_BROADCAST';
const setAccessToken = (token) => {
    localStorage.setItem(AUTH_TOKEN, token);
};
const setMSAccessToken = (token) => {
    localStorage.setItem(MS_AUTH_TOKEN, token);
};
const setSignalRToken = (token) => {
    localStorage.setItem(SIGNALR_TOKEN, token);
};
const setBrowserSessionId = (browser_id) => {
    localStorage.setItem(BROWSER_SESSION_ID, browser_id);
};
const setEventToken = (token) => {
    localStorage.setItem(EVENT_TOKEN, token);
};
const getAccessToken = () => {
    return localStorage.getItem(AUTH_TOKEN);
};
const getMSAccessToken = () => {
    return localStorage.getItem(MS_AUTH_TOKEN);
};
const getSignalRToken = () => {
    return localStorage.getItem(SIGNALR_TOKEN);
};
const getBrowserSessionId = () => {
    const browserId = localStorage.getItem(BROWSER_SESSION_ID);
    if (browserId === null || browserId === undefined || browserId === '') {
        const guid = uuid();
        localStorage.setItem(BROWSER_SESSION_ID, guid);
        return guid;
    }
    else {
        return browserId;
    }
};
const getEventToken = () => {
    return localStorage.getItem(EVENT_TOKEN);
};
const removeAccessToken = () => {
    localStorage.removeItem(AUTH_TOKEN);
};
const removeMSAccessToken = () => {
    localStorage.removeItem(MS_AUTH_TOKEN);
};
const removeSignalRToken = () => {
    localStorage.removeItem(SIGNALR_TOKEN);
};
const removeBrowserSessionId = () => {
    localStorage.removeItem(BROWSER_SESSION_ID);
};
const removeEventToken = () => {
    localStorage.removeItem(EVENT_TOKEN);
};
// Event language selection helpers (per event)
const getEventLanguageKey = (eventId) => `EVENT_LANGUAGE_${eventId}`;
const setEventLanguage = (eventId, languageId) => {
    try {
        localStorage.setItem(getEventLanguageKey(eventId), languageId);
    }
    catch {
        // ignore storage errors
    }
};
const getEventLanguage = (eventId) => {
    try {
        return localStorage.getItem(getEventLanguageKey(eventId));
    }
    catch {
        return null;
    }
};
const removeEventLanguage = (eventId) => {
    try {
        localStorage.removeItem(getEventLanguageKey(eventId));
    }
    catch {
        // ignore storage errors
    }
};
// Set once the user explicitly picks a language for an event, so IP-based
// detection never overrides their choice on a later visit or refresh.
const getEventLanguageManualOverrideKey = (eventId) => `EVENT_LANGUAGE_MANUAL_OVERRIDE_${eventId}`;
const setEventLanguageManualOverride = (eventId) => {
    try {
        localStorage.setItem(getEventLanguageManualOverrideKey(eventId), 'true');
    }
    catch {
        // ignore storage errors
    }
};
const getEventLanguageManualOverride = (eventId) => {
    try {
        return localStorage.getItem(getEventLanguageManualOverrideKey(eventId)) === 'true';
    }
    catch {
        return false;
    }
};
const removeEventLanguageManualOverride = (eventId) => {
    try {
        localStorage.removeItem(getEventLanguageManualOverrideKey(eventId));
    }
    catch {
        // ignore storage errors
    }
};
// Per-tab selected company helpers (sessionStorage)
const setSelectedCompanyIdForTab = (companyId) => {
    try {
        sessionStorage.setItem(SELECTED_COMPANY_ID_SESSION, JSON.stringify(companyId));
    }
    catch {
        // ignore storage errors
    }
};
const getSelectedCompanyIdForTab = () => {
    try {
        const value = sessionStorage.getItem(SELECTED_COMPANY_ID_SESSION);
        return value ? JSON.parse(value) : [];
    }
    catch {
        return null;
    }
};
const removeSelectedCompanyIdForTab = () => {
    try {
        sessionStorage.removeItem(SELECTED_COMPANY_ID_SESSION);
    }
    catch {
        // ignore storage errors
    }
};
// Cross-tab logout broadcast helper
const broadcastLogout = () => {
    try {
        localStorage.setItem(LOGOUT_BROADCAST, Date.now().toString());
    }
    catch {
        // ignore storage errors
    }
};
const LocalStorageService = {
    setAccessToken,
    setMSAccessToken,
    setSignalRToken,
    setBrowserSessionId,
    setEventToken,
    getAccessToken,
    getMSAccessToken,
    getSignalRToken,
    getBrowserSessionId,
    getEventToken,
    removeAccessToken,
    removeMSAccessToken,
    removeSignalRToken,
    removeBrowserSessionId,
    removeEventToken,
    // Event language selection (per event)
    setEventLanguage,
    getEventLanguage,
    removeEventLanguage,
    setEventLanguageManualOverride,
    getEventLanguageManualOverride,
    removeEventLanguageManualOverride,
    // Company selection (per-tab)
    setSelectedCompanyIdForTab,
    getSelectedCompanyIdForTab,
    removeSelectedCompanyIdForTab,
    // Cross-tab
    broadcastLogout
};
export default LocalStorageService;
